import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getValidImageUrl, SOURCES } from 'client/utils/image-helpers';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { AuthorName } from 'site-modules/shared/components/editorial/author-name/author-name';
import { AuthorTooltip } from 'site-modules/shared/components/editorial/author-tooltip/author-tooltip';

import './author-metadata.scss';

export function AuthorMetadata({
  avatar = null,
  name = null,
  title = null,
  link = null,
  aboutAuthor = null,
  byline = 'by',
  showBioTooltip = false,
}) {
  if (!name) {
    return null;
  }

  // If author metadata is in expanded mode (full description)
  const isExpanded = !showBioTooltip && typeof aboutAuthor === 'string' && !!aboutAuthor.length;

  return (
    <div className={classnames('author-metadata small', { expanded: isExpanded })}>
      {!!avatar && (
        <img
          className={classnames('photo me-0_5', { 'hidden-md-down': !isExpanded, 'me-0_5 me-md-1': isExpanded })}
          src={getValidImageUrl(avatar, SOURCES.STATIC)}
          alt=""
        />
      )}
      {byline}{' '}
      <AuthorName
        name={name}
        link={link}
        className={classnames('btn-sm author-link', {
          'pe-0_5': !isExpanded && !showBioTooltip,
          'p-0': isExpanded || showBioTooltip,
        })}
      />
      {showBioTooltip && <AuthorTooltip aboutAuthor={aboutAuthor} name={name} title={title} />}
      {isExpanded && (
        <ContentFragment componentToUse="p" classes="small">
          {aboutAuthor}
        </ContentFragment>
      )}
    </div>
  );
}

AuthorMetadata.propTypes = {
  avatar: PropTypes.string,
  name: PropTypes.string,
  link: PropTypes.string,
  title: PropTypes.string,
  aboutAuthor: PropTypes.string,
  byline: PropTypes.string,
  showBioTooltip: PropTypes.bool,
};
